module.exports = __webpack_public_path__ + "static/media/27OCHA9.d1476420.jpg";